export const API_URL = process.env.REACT_APP_API_URL;
export const BASE_IMAGE_URL = process.env.REACT_APP_BASE_IMAGE_URL;

export const SPORTS_URL = `${API_URL}/sports/`;
export const CITIES_URL = `${API_URL}/cities/`;
// export const BADGES_URL = `${API_URL}/badges/`;
